module.exports = {"230902011":"兴安社区公共服务站","230902012":"兴乐社区公共服务站","230902013":"兴富社区公共服务站","230902014":"兴秀社区公共服务站","230902015":"兴平社区公共服务站","230902016":"兴和社区公共服务站","230902017":"兴城社区公共服务站","230902018":"兴盛社区公共服务站","230902019":"北山社区公共服务站","230902020":"欣源社区公共服务站","230902021":"冬梅社区公共服务站","230902022":"枫叶社区公共服务站","230902023":"安居社区公共服务站","230902024":"河南社区公共服务站","230902025":"新立社区公共服务站","230902026":"新建社区公共服务站","230902027":"新城社区公共服务站","230902028":"缸窑沟社区公共服务站","230902100":"红旗镇","230902200":"长兴乡","230902480":"种畜场","230902500":"北兴农场","230902579":"黑龙江红兴隆农垦宝利采金"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230902.json
// module id = 711
// module chunks = 0